export var AdvisorTypes;
(function (AdvisorTypes) {
    AdvisorTypes["student"] = "student";
    AdvisorTypes["lawyer"] = "lawyer";
    AdvisorTypes["external_consultant"] = "external_consultant";
    AdvisorTypes["all"] = "all";
})(AdvisorTypes || (AdvisorTypes = {}));
